import React, { useState, useEffect } from 'react';
import { useRouteMatch, useHistory } from 'react-router-dom';

import { Row, Col } from '../components/Grid';

import logoItau from '../../assets/logo-itau.svg';

import { colors, LANDING_URL } from '../config';

const Steps = ({ total = 8, title, subtitle, image }) => {
  const [progress, setProgress] = useState(0);
  const history = useHistory();
  const match = useRouteMatch('/:step');
  const currentStep = match?.params?.step;

  // NOTE: Prevent browser back button behavior
  useEffect(() => {
    const customBack = () => {
      window.history.pushState(null, document.title, window.location.href);
      history.goBack();
    };

    if (currentStep && parseInt(currentStep) > 1) {
      window.history.pushState(null, document.title, window.location.href);
      window.addEventListener('popstate', customBack);
    }

    return () => {
      window.removeEventListener('popstate', customBack);
    };
  }, [currentStep, history]);

  useEffect(() => {
    setProgress(`${(parseInt(currentStep) / total) * 100}%`);
  }, [setProgress, currentStep, total]);

  // NOTE: Success screen doesn't have Steps
  if (currentStep === 'success') return null;

  return (
    <div className="steps-wrapper">
      <div className="container">
        <Row>
          <Col size={6}>
            <div style={{ position: 'relative' }}>
              <a href={LANDING_URL} className="steps-link">
                <img className="steps-image" src={logoItau} alt="" />
              </a>
            </div>

            <div className="steps">
              <div className="steps-body">
                <div className="progress-wrapper">
                  <div className="progress">
                    <div className="progress-indicator" />
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>

      <style jsx>{`
        .steps {
          align-items: center;
          display: flex;
          height: 48px;
        }

        .steps-image {
          height: 48px;
          margin-right: 16px;
          max-width: 64px;
        }

        .steps-link {
          position: absolute;
          margin-left: -100px;
          border: 0;
          cursor: pointer;
          padding: 0;
          background: transparent;
          font: inherit;
        }

        @media screen and (min-width: 993px) and (max-width: 1080px) {
          .steps-link {
            float: left;
            position: static;
            margin-left: 0;
          }
        }

        @media screen and (min-width: 1081px) and (max-width: 1200px) {
          .steps-link {
            float: none;
            position: absolute;
            margin-left: -68px;
          }
        }

        .steps-wrapper {
          background-color: ${colors.white};
          padding-top: 16px;
          padding-bottom: 16px;
          padding-left: 20px;
          padding-right: 20px;
          position: sticky;
          top: 0;
          z-index: 10;
        }

        .steps :global(.steps-body) {
          display: flex;
          flex-direction: column;
          flex: 1;
          line-height: 1.35;
        }

        .steps :global(.steps-body strong) {
          font-size: 18px;
          font-family: ${colors.baseFontDisplay};
          font-weight: 900;
        }

        .steps :global(.steps-body span) {
          font-size: 14px;
        }

        .progress-wrapper {
          align-items: center;
          display: flex;
        }

        .progress {
          background-color: #f2edea;
          border-radius: 3px;
          flex: 1;
          height: 5px;
          position: relative;
          width: 100%;
        }

        .progress-indicator {
          background-color: ${colors.orange};
          border-radius: 3px;
          height: 5px;
          left: 0;
          position: absolute;
          top: 0;
          transition: width 0.35s ease-in-out;
        }
      `}</style>

      <style jsx>{`
        .progress-indicator {
          width: ${progress || `${(1 / total) * 100}%`};
        }
      `}</style>
    </div>
  );
};

export default Steps;
